// extracted by mini-css-extract-plugin
export default {"mainWrapper":"bwr_NspavSdEQ7DeDr4t","first":"qFY2jsnIOAF0BrO262nT","image":"Vz4IB2WAByWvqq8ZJAzk","wrapper":"SdaaaixLS_mVwCvTsUf1","inner":"QGklFVyJP72U_YN_bKJV"};